import React from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './list';

export default () => (
  <Switch>
    <Route component={List} />
  </Switch>
);
